import { format, isValid, parse } from "date-fns";

import { DF_ABAS_DATE, DF_PL_DATE, EMPTY_VALUE } from "./consts/materialsConsts";

export const getProperUnit = (unit) => {
  switch (unit) {
    case "(179,62,0)":
      return "szt.";

    case "(166,62,0)":
      return "kg";

    case "(180,62,0)":
      return "kpl";

    case "(160,62,0)":
      return "m";

    case "(169,62,0)":
      return "tona";

    case "(187,62,0)":
      return "arkusz";

    default:
      return unit;
  }
};

const parseAbasDate = (dateString) => {
  if (dateString === null || dateString === undefined || dateString === "") {
    return null;
  }
  const parsed = parse(String(dateString), DF_ABAS_DATE, new Date());
  return isValid(parsed) ? parsed : null;
};

export const formatAbasDate = (dateString) => {
  const parsed = parseAbasDate(dateString);
  return parsed ? format(parsed, DF_PL_DATE) : EMPTY_VALUE;
};

export const getAbasDateTime = (dateString) => {
  const parsed = parseAbasDate(dateString);
  return parsed ? parsed.getTime() : Number.NaN;
};

export const getValue = (value) =>
  value === "" || value === null || value === undefined ? EMPTY_VALUE : value;

/**
 * The endpoint may hand back either a plain list of materials or an object
 * keyed by id, the way /api/orders does. Both collapse to a list here.
 */
export const normalizeMaterials = (data) => {
  if (Array.isArray(data)) {
    return data;
  }
  if (data && typeof data === "object") {
    return Object.values(data);
  }
  return [];
};

/**
 * Guards the materials tab: a missing or expired token must never reach the API.
 * Kept tolerant on purpose - a token we cannot decode counts as invalid.
 */
export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const payload = token.split(".")[1];
    if (!payload) return false;
    const normalized = payload.replace(/-/g, "+").replace(/_/g, "/");
    const decoded = JSON.parse(
      decodeURIComponent(
        atob(normalized)
          .split("")
          .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
          .join("")
      )
    );
    return decoded.exp > Math.floor(Date.now() / 1000);
  } catch (error) {
    return false;
  }
};
